<template><section><h2>Challenge Descriptions</h2>
<p>DinoFun World is a typical modest-sized amusement park, sitting on about 215 hectares and hosting thousands of visitors each day. It has a small town feel, but it is well known for its exciting rides and events.</p>
<p>One event last year was a weekend tribute to Scott Jones, internationally renowned football (“soccer,” in US terminology) star. Scott Jones is from a town nearby DinoFun World. He was a classic hometown hero, with thousands of fans who cheered his success as if he were a beloved family member. To celebrate his years of stardom in international play, DinoFun World declared “Scott Jones Weekend”, where Scott was scheduled to appear in two stage shows each on Friday, Saturday, and Sunday to talk about his life and career. In addition, a show of memorabilia related to his illustrious career would be displayed in the park’s Pavilion.</p>
<p>However, the event did not go as planned. Scott’s weekend was marred by crime and mayhem perpetrated by a poor, misguided and disgruntled figure from Scott’s past.</p>
<p>While the crimes were rapidly solved, park officials and law enforcement figures are interested in understanding just what happened during that weekend to better prepare themselves for future events. They are interested in understanding how people move and communicate in the park, as well as how patterns changes and evolve over time, and what can be understood about motivations for changing patterns.</p>
<p>You have access to movement tracking information for all of the paying park visitors over the three days of the Scott Jones celebration. This data contains many patterns that are useful for planning park operations. On this particular weekend a crime occurred and the data likely contains information pertinent to that crime.</p>
<p>Use visual analytics to analyze the available data and develop responses to the questions below. In addition, prepare a video that shows how you used visual analytics to solve this challenge. We encourage novel visual representations and analytic approaches!</p>
<h2>Project Task</h2>
<ul>
<li>
<p>Characterize the attendance at the park on this weekend. Describe up to twelve different types of groups at the park on this weekend.</p>
<ul>
<li>How big is the group type?</li>
<li>Where does this type of group like to go in the park?</li>
<li>How common is this type of group?</li>
<li>What are your other observations about this type of group?</li>
<li>What can you infer about the group?</li>
<li>If you were to make one improvement to the park to better meet this group’s needs, what would it be?</li>
</ul>
</li>
<li>
<p>Are there notable differences in the patterns of activity on in the park across the three days? Please describe the notable difference you see.</p>
</li>
<li>
<p>What anomalies or unusual patterns do you see? Describe no more than 10 anomalies, and prioritize those unusual patterns that you think are most likely to be relevant to the crime.</p>
</li>
</ul>
<h2>Schedule</h2>
<ul>
<li>
<p>Fetch Dataset, analyse tasks, and make a plan to solve it (2-3 week)</p>
</li>
<li>
<p>Process data, implement analysis framework (4-7 week)</p>
</li>
<li>
<p>Mid-term inspection (8 week)</p>
</li>
<li>
<p>Implement analysis system (9-12 week)</p>
</li>
<li>
<p>Inter-team evaluation and modification (13-15 week)</p>
</li>
<li>
<p>Final inspection (16-17 week)</p>
</li>
</ul>
<h2>Resources</h2>
<ul>
<li>http://www.vacommunity.org/2015+VAST+Challenge%3A+MC1</li>
</ul>
</section></template><script>export default {components:{}}</script>